var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", { staticClass: "col-9 mt-5" }, [
    _c("p", {
      directives: [{ name: "to-lang", rawName: "v-to-lang" }],
      staticClass: "text-justify lead",
      attrs: { tabindex: "-1", id: "about-para-1" },
      domProps: { innerHTML: _vm._s(_vm.$t("what_is_unterm")) },
    }),
    _vm._v(" "),
    _c("p", {
      directives: [{ name: "to-lang", rawName: "v-to-lang" }],
      staticClass: "text-justify lead",
      domProps: { innerHTML: _vm._s(_vm.$t("about_unterm")) },
    }),
    _vm._v(" "),
    _c("p", {
      directives: [{ name: "to-lang", rawName: "v-to-lang" }],
      staticClass: "text-justify lead",
      domProps: { innerHTML: _vm._s(_vm.$t("unterm_portal")) },
    }),
    _vm._v(" "),
    _c("p", {
      directives: [{ name: "to-lang", rawName: "v-to-lang" }],
      staticClass: "text-justify lead",
      domProps: { innerHTML: _vm._s(_vm.$t("unterm_language")) },
    }),
    _vm._v(" "),
    _c("p", {
      directives: [{ name: "to-lang", rawName: "v-to-lang" }],
      staticClass: "text-justify lead",
      domProps: { innerHTML: _vm._s(_vm.$t("unterm_about_portal")) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }